import { FOLLOW_UPS } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

export default function GenSui() {
  return (
    <section id="gensui" className="mx-auto max-w-7xl px-4 md:px-6 py-16">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading
          kicker="蹲后续"
          title="反转在路上，别走开"
          desc="事件都有后续。跟着时间线蹲最新进度，第一时间吃上热乎的反转与二次反转。"
        />
        <a
          href="#subscribe"
          className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-accent-300 bg-accent-100 px-5 py-2.5 text-sm font-medium text-accent-700 transition-colors hover:bg-accent-200"
        >
          <i className="ri-notification-2-line"></i>
          开蹲新反转
        </a>
      </div>

      <div className="mt-8 grid gap-5 lg:grid-cols-2">
        {FOLLOW_UPS.map((f) => (
          <div
            key={f.id}
            className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6"
          >
            <div className="flex items-center gap-3">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-lg bg-primary-100 text-xl">
                {f.emoji}
              </span>
              <div className="min-w-0">
                <h3 className="truncate text-base font-bold text-foreground-950">{f.title}</h3>
                <span className="mt-0.5 inline-block rounded bg-accent-100 px-1.5 py-0.5 text-[11px] text-accent-700">
                  {f.category}
                </span>
              </div>
            </div>

            <ol className="relative mt-5 space-y-4 border-l-2 border-background-200 pl-5">
              {f.episodes.map((ep) => (
                <li key={ep.ver} className="relative">
                  <span
                    className={`absolute -left-[27px] grid h-4 w-4 place-items-center rounded-full ${
                      ep.isNew ? "bg-accent-500 ring-4 ring-accent-100" : "bg-background-300"
                    }`}
                  >
                    {ep.isNew && <i className="ri-arrow-right-up-line text-[8px] text-background-50"></i>}
                  </span>
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`rounded px-2 py-0.5 text-[11px] font-medium ${
                        ep.isNew ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {ep.ver}
                    </span>
                    <span className="text-xs text-foreground-500">{ep.time}</span>
                  </div>
                  <p className="mt-1 text-sm text-foreground-800">{ep.title}</p>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </section>
  );
}